import { BaseComponent } from "../../Library/BaseComponent";
import { OnInit, Component, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { StaffHealthDataService } from "../../Services/StaffHealthDataService";
import { AnswerOption, AnswerValueOption } from "../../Models/RequestModels";
import { AnswerTypes } from "../../Models/EnumModels";
import { UUID } from "angular2-uuid";
import { NgbActiveModal, NgbPanelChangeEvent, NgbAccordion } from "@ng-bootstrap/ng-bootstrap";
import * as _ from 'lodash';

@Component({
    selector: 'QuestionResponseConfiguration',
    templateUrl: './QuestionResponseConfiguration.html'
})
export class QuestionResponseConfiguration extends BaseComponent implements OnInit {

    answerOptions: AnswerOption[] = [];
    answerTypes = AnswerTypes;
    selectedAnswer?: AnswerOption;
    isQuestionMandatory = true;
    questionDesc?: string;
    
    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected activeModal: NgbActiveModal,
        protected staffHealthService: StaffHealthDataService) {

        super(translate, toastr, route, router, masterService);
        this.answerOptions = this.staffHealthService.GetAnswerResponses().slice();
    }

    ngOnInit() { }

    setSelectedAnswerOption(option: AnswerOption, questionDesc?: string, isQuestionMandatory = true) {
        const cloneOption = _.cloneDeep(option);
        const index = _.findIndex(this.answerOptions, { type: option.type })
        if (index >= 0) {
            this.answerOptions.splice(index, 1, cloneOption);
            this.selectedAnswer = cloneOption;
            this.isQuestionMandatory = isQuestionMandatory;
            this.questionDesc = questionDesc;
        }
    }

    didSelectAnswerType(event: AnswerOption) {
        if (!event) {
            return;
        }
        this.selectedAnswer = event;
    }

    onPanelChange(event: NgbPanelChangeEvent) {
        const panelId = event.panelId;
        this.selectedAnswer = _.find(this.answerOptions, { id: panelId });
    }

    addValueOption(option: AnswerOption, valueOpt?: AnswerValueOption) {
        option.values = option.values || []
        const index = valueOpt
            ? _.findIndex(option.values, { value: valueOpt.value })
            : option.values.length;
        if (index >= 0) {
            option.values.splice(index, 0, {
                uuid: UUID.UUID(),
                label: '',
                isValid: false
            })
        }
    }

    deleteValueOption(option: AnswerOption, valueOpt: AnswerValueOption) {
        let values = option.values || [];
        const index = _.findIndex(values, { value: valueOpt.value })
        if (index >= 0) {
            values.splice(index, 1);
        }
        option.values = values;
    }

    cancel() {
        this.activeModal.dismiss();
    }

    validate(): string[] {
        const errors = [];
        // no answer
        if (!this.selectedAnswer) {
            errors.push('ERR.SELECT_RESPONSE_TYPE');
            return errors;
        }
        // based on type
        switch (this.selectedAnswer.type) {
            case AnswerTypes.Text:
                break;
            case AnswerTypes.Numerical:
                if (!_.isNumber(this.selectedAnswer.attributes.min)
                    || !_.isNumber(this.selectedAnswer.attributes.max)) {
                    errors.push('ERR.ENTER_MIN_MAX_VALUES');
                }
                break;
            case AnswerTypes.OptionalBool:
            case AnswerTypes.Rating:
            case AnswerTypes.Radio:
            case AnswerTypes.Checkbox:
                if (!this.selectedAnswer.values
                    || this.selectedAnswer.values.length == 0) {
                    errors.push('ERR.RESPONSE_OPTIONS_EMPTY');
                } else if (_.some(this.selectedAnswer.values, v => !v.label || v.label.length == 0)) {
                    errors.push('ERR.RESPONSE_OPTION_LABEL_EMPTY');
                }
                break;
        }

        return errors;
    }

    submit() {
        this.ClearErrors();
        const errors = this.validate();
        if (errors.length) {
            errors.forEach(e => this.AddError(e));
            return;
        }
        if (this.selectedAnswer) {
            this.activeModal.close(this.selectedAnswer);
        } else {
            console.warn('No Answer Response Selected')
        }
    }

    didChangeResponseType(selectedType: AnswerTypes) {
        this.ClearErrors();
    }


}
